import Tags from "../tags/Tags";
import Like from "./Like";
import Save from "./Save";

export default function SinglePost({ post }) {
  const {id, title, description,tags,isSaved, image, likes } = post;
  return (
    <main className="post">
      <img
        src={image}
        alt={title}
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tags.map((tag)=> <Tags tags={tag} key={tag} />)} 
        </div>
        <div className="btn-group">
          <Like likes={likes} postId ={id} />
         <Save isSaved={isSaved} postId={id} />
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
}
